import { render, staticRenderFns } from "./ApplicationUserCustomDashboardList.vue?vue&type=template&id=5f4d4b3a&scoped=true"
import script from "./ApplicationUserCustomDashboardList.vue?vue&type=script&lang=js"
export * from "./ApplicationUserCustomDashboardList.vue?vue&type=script&lang=js"
import style0 from "./ApplicationUserCustomDashboardList.vue?vue&type=style&index=0&id=5f4d4b3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d4b3a",
  null
  
)

export default component.exports